// Auth utilities — replaces Firebase Auth
// JWT token stored in localStorage, accessed via getToken()/setToken()

const TOKEN_KEY = 'onikanji_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
